import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement } from "react";
import { Slot } from "./Slot";
import { useTabsWithChildren } from "./Tabs.shared";
export * from "./TabContext";
export * from "./TabList";
export * from "./TabSlot";
export * from "./TabTrigger";
export * from "./Tabs.shared";
function Tabs(props) {
  var { children, asChild, options, ...rest } = props;
  var Comp = asChild ? Slot : "div";
  var { NavigationContent } = useTabsWithChildren({
    children: asChild && /* @__PURE__ */ isValidElement(children) && children.props && typeof children.props === "object" && "children" in children.props ? children.props.children : children,
    ...options
  });
  return /* @__PURE__ */ _jsx(Comp, {
    ...rest,
    children: /* @__PURE__ */ _jsx(NavigationContent, {
      children
    })
  });
}
export {
  Tabs
};
//# sourceMappingURL=Tabs.js.map
